import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Button from "@weave-design/button";
import Checkbox from "@weave-design/checkbox";
import Label from "@weave-design/label";
import { ProcessingPane } from "../../../processing-pane/processingPane";
import { rootElement } from "../../../shared";
import "../../../../assets/buildingWideChangesStyles.css";
import eventBus from "../../eventBus/eventDispatcher";

export const BuildingWideChangesContent = () => {
    const [isChecked, setIsChecked] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        const onProcessComplete = () => {
            setIsProcessing(false);
        };

        eventBus.addEventListener("Dextall.BuildingWideChanges.ProcessComplete", onProcessComplete);

        return () => {
            eventBus.removeEventListener("Dextall.BuildingWideChanges.ProcessComplete", onProcessComplete);
        };
    }, []);

    const onCheckboxChange = (checked: boolean) => {
        setIsChecked(checked);
    };

    const markAllPanelTypesWithoutCladding = () => {
        setIsProcessing(true);

        eventBus.dispatchEvent({
            type: "Dextall.BuildingWideChanges.SetPanelTypes.WithoutCladding",
            payload: isChecked,
        });
    };

    return (
        <div className="bwc-content">
            <div className="bwc-top">
                <Label>Without claddings: </Label>
                <Checkbox
                    checked={isChecked}
                    onChange={onCheckboxChange}
                />
            </div>

            <div className="bwc-bottom">
                {isProcessing &&
                    ReactDOM.createPortal(
                        <ProcessingPane
                            isVisible={true}
                            title="Updating panel types..."
                            message="Changing without claddings mark..."
                        />,
                        rootElement,
                    )}

                <Button
                    style={{ width: "50px" }}
                    type="primary"
                    size="standard"
                    title="Apply"
                    width="grow"
                    onClick={markAllPanelTypesWithoutCladding}
                />
            </div>
        </div>
    );
};
